import React from 'react';
import {searchPractices} from '../../actions/index'
import {Link} from 'react-router'
import SearchIcon from '../../images/icons/SearchIcon'

class PracticeSearch extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            'search_text': '',
            typing: false,
            typingTimeout: 0,
            'results': []
        }
        this.itemClick = this.itemClick.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.fetchResults = this.fetchResults.bind(this)
    }

    shouldComponentUpdate(nextState) {
		if (nextState.search_text ===  this.state.search_text) {
			return false;
		}
		return true;
	}

    onSearchChange(e) {
        const {value} = e.target;
        const { search_text } = this.state;
        const self = this;

        if (value === '') {
            this.setState({'search_text': value, 'results': []})
            return
        }

        this.setState({'search_text': value});

        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }

        self.setState({
            search_text: value,
            results: [],
            typing: false,
            typingTimeout: setTimeout(() => {
                this.fetchResults(value)
            }, 500)
        });
    }

    fetchResults(s) {
        searchPractices(s).then(results => {
            this.setState({
                "results": results || []
            })
        })
    }

    itemClick() {
        const { itemClick } = this.props;

        this.setState({
            'search_text': '',
            "results": []
        })
        itemClick()
    }

    render() {
        const {search_text, results} = this.state;

        return (<div className="search-box">
            <div className="search-box__header">
                Looking for a practice?
            </div>
            <div className="search-box__content">
                <div className="search-box__input">
                    <SearchIcon />
                    <input type="search" onChange={this.onSearchChange} value={search_text} placeholder="Search for a practice"/>
                </div>
                <ul className="search-box__results">
                    {
                        results.map(result => (<li key={`search-${result._id}`}
                        onClick={this.itemClick}
                        className="result">
                        {this.props.admin ? 
                            <Link to={`/admin/practices/${result._id}`}>{result.name}</Link>
                            :
                            <Link to={`/practice/${result.slug}`}>{result.name}</Link>
                        }
                        </li>))
                    }
                </ul>
            </div>
        </div>)
    }
}

PracticeSearch.defaultProps = {
    itemClick: () => true
}

export default PracticeSearch



// WEBPACK FOOTER //
// ./src/components/practice/PracticeSearch.jsx